import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  Col,
  Form,
  InputGroup,
  Pagination,
  Row,
  Table,
} from "react-bootstrap";
import "./AdminFinance.css";
import { Store } from "../../Store";
import axios from "axios";
import ToastIt from "../../components/Toast";
import { CSVLink } from "react-csv";
import { getError } from "../../Utils/GetErrors";
import ConfirmIt from "../../Utils/ConfirmIt";
import { Trash } from "react-bootstrap-icons";

function AdminFinance() {
  const { state, dispatch: ctxDispatch } = useContext(Store);
  const { userInfo, baseUrl, allRechargeRequests, users } = state;

  const [requestToProcess, setRequestToProcess] = useState(null);
  // const [confirmAction, setConfirmAction] = useState(null);
  const [csvData, setCsvData] = useState([]);
  const [rechargeRequests, setRechargeRequests] = useState([]);

  const [search, setSearch] = useState("");
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [variance, setVariance] = useState("");

  const [userId, setUserId] = useState("");
  const [amount, setAmount] = useState("");

  const [showConfirm, setShowConfirm] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  // const [confirmAction, setConfirmAction] = useState(null);

  // fetch update from state
  useEffect(() => {
    if (allRechargeRequests && allRechargeRequests.length > 0) {
      setRechargeRequests(allRechargeRequests);
    } else {
      setRechargeRequests([]);
    }
  }, [allRechargeRequests]);

  // Filtered Recharge Requests
  const filteredRecharges =
    rechargeRequests && rechargeRequests.length > 0
      ? rechargeRequests.filter((recharge) =>
          // recharge.receiver.includes(search)
          Object.values(recharge).some((value) =>
            value.toString().toLowerCase().includes(search.toLowerCase())
          )
        )
      : [];

  // Pagination Logic
  const totalPages = Math.ceil(filteredRecharges.length / itemsPerPage);
  const paginatedRecharges = filteredRecharges.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleWalletUpdate = async () => {
    if (!userInfo.token) {
      return;
    } else {
      const selectedUser = await users.find((user) => user.username === userId);
      const calledName = selectedUser ? selectedUser.username : "";
      const chosenId = selectedUser ? selectedUser._id : "";
      if (!calledName) return;

      if (
        window.confirm(
          `Are you sure you want to update ${calledName}'s wallet with ¢${amount}?`
        )
      ) {
        try {
          const { data } = await axios.put(
            `${baseUrl}/user/balance`,
            { chosenId, amount },
            {
              headers: { Authorization: `Bearer ${userInfo.token}` },
            }
          );
          setToastMessage(
            `${calledName}'s wallet updated successfully. New balance: ¢${data.balance}`
          );
          setVariance("success");
          setShowToast(true);
          setAmount("");
          setUserId("");
        } catch (error) {
          setToastMessage(getError(error));
          setVariance("danger");
          setShowToast(true);
        }
      } else {
        return;
      }
    }
  };

  const handleApprove = async (id) => {
    setShowConfirm(true);
    setAlertMessage("Are you sure you want to approve this request?");
    setRequestToProcess(id)
    // setConfirmAction(() => () => confirmActionHandler(id));
    // console.log('confirmAction',confirmAction)
  };
  
  const handleDecline = async (id) => {
    // console.log(id)
    setShowConfirm(true);
    setAlertMessage("Are you sure you want to decline this request?");
    setRequestToProcess(id)
    // setConfirmAction(() => () => confirmActionHandler(id));
  };

  const confirmActionHandler = async () => {
    // console.log('fromConfirm',requestToProcess)
    if(alertMessage === "Are you sure you want to approve this request?"){
    try {
      const { data } = await axios.put(
        `${baseUrl}/recharge/${requestToProcess}/approve`,
        {},
        {
          headers: { Authorization: `Bearer ${userInfo.token}` },
        }
      );
      // console.log('returnedData',data)

      const updatedRequests = rechargeRequests.map((req) =>
        req._id === requestToProcess ? { ...req, status: "approved" } : req
      );
      ctxDispatch({ type: "GET_RECHARGE_REQUESTS", payload: updatedRequests });
      setRechargeRequests(updatedRequests);
      ctxDispatch({ type: "USER_RECHARGE", payload: data.balance });
      setVariance("success");
      setToastMessage("Recharge request approved");
      setShowToast(true);

      // SEND SMS
      function sendPaymentNotification2User(phone) {
        if (phone) {
          try {
            const apiUrl = `https://apps.mnotify.net/smsapi?key=zwNY4rjo1XWnMXn8Om7Q8gk1U&to=233${phone}&msg=Your recharge request has been approved. Your wallet balance is now ¢${data.balance}&sender_id=KYE-TECH`;
            fetch(apiUrl).then((response) => console.log(response));
          } catch (error) {
            console.error("Error sending SMS:", error);
          }
        }
      }
      sendPaymentNotification2User(data.user.phone);
    } catch (error) {
      setToastMessage(getError(error));
      setVariance("danger");
      setShowToast(true);
    }
    setShowConfirm(false);
} else {
    // const confirmActionHandler = async (id) => {
      try {
        const {data}= await axios.put(
          `${baseUrl}/recharge/${requestToProcess}/decline`,
          {},
          {
            headers: { Authorization: `Bearer ${userInfo.token}` },
          }
        );
        // console.log('returnedData',data)
        const updatedRequests = rechargeRequests.map((req) =>
          req._id === requestToProcess ? { ...req, status: "declined" } : req
        );
        ctxDispatch({ type: "GET_RECHARGE_REQUESTS", payload: updatedRequests });
        setRechargeRequests(updatedRequests);
        // ctxDispatch({ type: "USER_RECHARGE", payload: data.balance });
        setVariance("success");
        setToastMessage("Recharge request declined");
        setShowToast(true);
  
        // SEND SMS
        function sendPaymentNotification2User(phone) {
          if (phone) {
            try {
              const apiUrl = `https://apps.mnotify.net/smsapi?key=zwNY4rjo1XWnMXn8Om7Q8gk1U&to=233${phone}&msg=Your recharge request has been rejected. Your wallet balance is still ¢${data.user.balance}&sender_id=KYE-TECH`;
              fetch(apiUrl).then((response) => console.log(response));
            } catch (error) {
              console.error("Error sending SMS:", error);
            }
          }
        }
        sendPaymentNotification2User(data.user.phone);
      } catch (error) {
        setToastMessage(getError(error));
        setVariance("danger");
        setShowToast(true);
      }
      setShowConfirm(false);
    };
  };

  const handleDeleteRequest = async (orderId) => {
   if(window.confirm(
      `Are you sure you want to delete request with ref ${orderId.rechargeId}?`
    )){
      try {
              // Send DELETE request to the backend
              await axios.delete(`${baseUrl}/recharge/delete/${orderId._id}`, {
                headers: { Authorization: `Bearer ${userInfo.token}` },
              });
          
              // Update the Orders state to remove the deleted order
              setRechargeRequests((prevOrders) => prevOrders.filter((order) => order._id !== orderId._id));
               setToastMessage(`Request ${orderId.rechargeId} has been successfully deleted.`);
                setVariance("success");
                setShowToast(true);
               
            } catch (error) {
              console.error("Error deleting request:", error);
               setToastMessage("Failed to delete the request. Please try again");
                setVariance("danger");
                setShowToast(true);
            }

    }else{
      return;
    }
}
   const deleteAllRequests = async () => {
         if(window.confirm(`Are you sure you want to delete all requests?`)){
      try {
        await axios.delete(`${baseUrl}/recharge/del-all-requests`);
        setRechargeRequests([]);
        setToastMessage(`All requests deleted successfully`);
        setVariance("success");
        setShowToast(true);
      } catch (error) {
        console.error('Error deleting requests:', error);
        setToastMessage(`Error deleting all requests`);
        setVariance("danger");
        setShowToast(true);
      }
      } else{
        return;
      }
    };

  // FOR CSV DATA
  // useEffect(() => {
      const exportHandler = () => {
    const csvData = rechargeRequests.map((recharge) => ({
      Date: recharge.date,
      Username: recharge.username,
      TotalAmount: recharge.totalAmount,
      Status: recharge.status,
    }));
    setCsvData(csvData);
  };
  // }, [rechargeRequests]);

  // CSS STYLING
  const formContainerStyle = {
    flex: 1,
  };
  // console.log('adminFin',users)

  return (
    <>
      <h3 className='text-center text-primary my-3'>CREDIT/DEBIT USER</h3>
      <hr/>
      <Form className="px-5">
        <Row>
          <Form.Group as={Col} xs={12} md={4} controlId="userId">
            <Form.Label>Choose User</Form.Label>
            {/* <Form.Control 
              as="select"
              value={userId}
              onChange={(e) => setUserId(e.target.value)}
            >
              <option value="">Select User</option>
              {users.map(user => (
                <option key={user._id} value={user.username}>
                  {user.username}
                </option>
              ))}
            </Form.Control> */}

            <Form.Control
              type="text"
              placeholder="user"
              value={userId}
              onChange={(e) => setUserId(e.target.value)}
              list="userList"
            />
            <datalist id="userList">
              {users
                .filter((user) =>
                  user.username.toLowerCase().includes(userId.toLowerCase())
                )
                .map((user) => (
                  <option key={user._id} value={user.username}>
                    {user.username}
                  </option>
                ))}
            </datalist>
          </Form.Group>
          <Form.Group as={Col} xs={12} md={4} controlId="amount">
            <Form.Label>Set Amount</Form.Label>
            <Form.Control
              type="number"
              placeholder="amount"
              value={amount}
              onChange={(e) =>
                setAmount(e.target.value === "" ? "" : Number(e.target.value))
              }
            />
          </Form.Group>
          <Form.Group as={Col} xs={12} md={4} controlId="amount">
            <Form.Label>&nbsp; </Form.Label>
            <Button
            className="w-100"
            variant="primary"
            onClick={handleWalletUpdate}
            disabled={!userId || amount === ""}
          >
            Execute
          </Button>
          </Form.Group>
        </Row>
      </Form>
      <hr />
      <div className="container mt-4 py-1" style={formContainerStyle}>
        <h3 className="text-center text-primary my-3">TOPUP HISTORY</h3>
          <span className="float-end text-danger" style={{cursor:'pointer'}} onClick={() => deleteAllRequests()}>DELETE ALL REQUESTS</span>
        <hr />
        <div className="d-flex justify-content-between mb-2">
          <Form.Group controlId="entriesSelect">
            <Form.Label>Show</Form.Label>{' '}
            <Form.Control
              as="select"
              value={itemsPerPage}
              onChange={(e) => setItemsPerPage(Number(e.target.value))}
              style={{ width: "auto", display: "inline-block" }}
            >
              {[10, 20, 50, 100].map((value) => (
                <option key={value} value={value}>
                  {value}
                </option>
              ))}
            </Form.Control>
            <span> entries</span>
          </Form.Group>
          <InputGroup className="search-bar" style={{ maxWidth: "300px" }}>
            <Form.Control
              type="text"
              placeholder="Search"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </InputGroup>
        </div>
        <div style={{ overflowX: "auto" }}>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Date</th>
                <th>Reference</th>
                <th>User</th>
                <th>Amount</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {paginatedRecharges.map((request) => (
                <tr key={request._id}>
                  <td>{request.createdAt}</td>
                  <td>{request.rechargeId}</td>
                  <td>{request.user.username}</td>
                  <td>{request.amount}</td>
                  <td>{request.status}</td>
                  <td>
                    {request.status === "pending" ? (
                      <>
                        <Button
                          variant="success"
                          size="sm"
                          className="px-1 py-0"
                          onClick={() => handleApprove(request._id)}
                        >
                          <small>Approve</small>
                        </Button>{" "}
                        <Button
                          variant="danger"
                          size="sm"
                          className="px-1 py-0"
                          onClick={() => handleDecline(request._id)}
                        >
                          <small>Decline</small>
                        </Button>
                      </>
                    ) : request.status === "declined" ? (
                      <Button
                        variant="danger"
                        size="sm"
                        className="px-1 py-0 w-100"
                        disabled
                      >
                        <small>Declined</small>
                      </Button>
                    ) : (
                      <Button
                        variant="success"
                        size="sm"
                        className="px-1 py-0 w-100"
                        disabled
                      >
                        <small>Approved</small>
                      </Button>
                    )}
                  </td>
                 <td onClick={() => handleDeleteRequest(request)}>
                    <small><Trash size={15}/></small>
                  </td>                  
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
        <div className="d-flex justify-content-between">
          <span>
            Showing {paginatedRecharges.length} of {filteredRecharges.length}{" "}
            entries
          </span>
          <Pagination>
            {[...Array(totalPages)].map((_, index) => (
              <Pagination.Item
                key={index}
                active={index + 1 === currentPage}
                onClick={() => handlePageChange(index + 1)}
              >
                {index + 1}
              </Pagination.Item>
            ))}
          </Pagination>
        </div>
      <CSVLink
        className="btn btn-primary p-2 my-5 text-center w-100"
        data={csvData}
        filename={"GhanaBundles-admin-finance.csv"}
        onClick={exportHandler}
      >
        Export to Excel
      </CSVLink>
      </div>
      <ToastIt
        Variance={variance}
        Message={toastMessage}
        ShowToast={showToast}
        OnClose={() => setShowToast(false)}
      />
      <ConfirmIt
        Message={alertMessage}
        ShowConfirm={showConfirm}
        OnClose={() => setShowConfirm(false)}
        onConfirm={confirmActionHandler}
      />
    </>
  );
}

export default AdminFinance;